export const useGhadiyaLogic = (num) => {
  const table = [];

  for (let i = 1; i <= 10; i++) {
    table.push(`${num} × ${i} = ${num * i}`);
  }

  const speak = (line) => {
    const msg = new SpeechSynthesisUtterance(line);
    msg.lang = "hi-IN";
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(msg);
  };

  return { table, speak };
};
